import { CouponType } from "@/pages/desktop-coupon/constant/index";
import { dateFormatter } from "project-config/utils/date-formatter";
import { isOverTimeCoupon } from "../helper/isOverTimeCoupon";
import { ICouponDetailInfo, ICouponListInfo } from "../types";
import { getWayFilter } from "./coupon-filter";

export const CouponList: ICouponListInfo[] = [
  {
    name: "coupon_animation_applicable",
    data: [],
    sum: 0,
    amount: 0,
    type: CouponType.Desktop,
  },
];

export const CouponContentList = (isSubAccount: boolean) =>
  new Map([
    [
      CouponType.Desktop,
      [
        {
          title: "coupon_get_way",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: getWayFilter(data.getWay),
            };
          },
          visible: (isExpired?: boolean) => {
            return true;
          },
        },
        {
          title: "coupon_get_time",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: dateFormatter(data.effectiveDate, "yyyy-MM-dd"),
            };
          },
          visible: (isExpired?: boolean) => {
            return true;
          },
        },
        {
          title: "coupon_expired_time_title",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: dateFormatter(data.expireDate, "yyyy-MM-dd"),
            };
          },
          visible: (isExpired?: boolean) => {
            return true;
          },
        },
        {
          title: "coupon_pages_has_used_result",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value:
                isOverTimeCoupon(data.expireDate, !!data.isExpired) &&
                data.couponBalance !== 0
                  ? "coupon_pages_has_expired"
                  : !(data.destName && data.operateTime)
                  ? "coupon_pages_used_up"
                  : isSubAccount
                  ? "coupon_pages_transfer_to_user"
                  : "coupon_pages_transfer_to_subuser",
            };
          },
          visible: (isExpired?: boolean) => {
            return isExpired;
          },
        },
      ],
    ],
  ]);

export const CouponRulesList = [
  {
    rules: [
      "desktop_rules_content_1",
      "desktop_rules_content_2",
      "desktop_rules_content_3",
      "desktop_rules_content_4",
    ],
    title: "",
    key: CouponType.Desktop,
  },
];
